import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PaginationService} from './pagination.service';
import {Observable, of as observableOf} from 'rxjs';
import {ShippingSystemType} from '../_models';
import {map} from 'rxjs/operators';

@Injectable()
export class ShippingSystemService extends PaginationService {
  constructor(protected http: HttpClient) {
    super(http, 'shipping_systems');
  }

  getTypes(): Observable<ShippingSystemType[]> {
    let typesString = sessionStorage.getItem('shippingSystemTypes');

    if (typesString) {
      //get the cached crm types
      return observableOf(JSON.parse(typesString));
    }
    else {
      //crm types not cached, so get it from the server
      return this.http.get<any>(this.route + '/types/').pipe(map((types: ShippingSystemType[]) => {
        sessionStorage.setItem('shippingSystemTypes', JSON.stringify(types)); //cache the crm types returned from the server
        return types;
      }));
    }
  }
}
